













import { Component, Vue, Prop } from 'vue-property-decorator'
import { RoleId } from '@/enum'
import SmallCard from './SmallCard.vue'
import RoleView from '@/components/Common/RoleView.vue'
import SimpleModal from '@/components/Utils/modal/SimpleModal.vue'

@Component({
  components: {
    SmallCard,
    RoleView,
    SimpleModal
  }
})
export default class SmallCardList extends Vue {
  @Prop() roleIds!: RoleId[]
  selectedRoleId: RoleId | '' = '';
  show = false;

  selectRoleId (roleId: RoleId) {
    this.selectedRoleId = roleId
    this.show = true
  }

  close () {
    this.show = false
    this.selectedRoleId = ''
  }
}
